import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export function useDidUpdateEffect(fn: EffectCallback, inputs: DependencyList) {
    const didMountRef = useRef(false);

    useEffect(() => {
        if (didMountRef.current) fn();
        else didMountRef.current = true;
    }, inputs); // eslint-disable-line react-hooks/exhaustive-deps
}
